import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {getAdminEmpresa, getOperadorRemarcacao, PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';

class AcoesRemarcacaoCancelamento extends Component {

  exibirImprimirCupomCancelamento() {
    if (this.props.reserva.situacaoReserva === 'CANCELADO') {
      const url = `/recibo-cancelamento-reserva?reserva=${this.props.reserva.id}`;
      return (
        <div>
          <a className="dropdown-item"
             onClick={() => {
               this.props.history.push(url)
             }}> Emitir cupom de cancelamento
          </a>
        </div>
      )
    }
  }


  render () {
    return (
      <div className="col">
        <div className="dropdown">
          <span className="titulo-mobile">Ações:</span>
          <button className="btn btn-link btn-acoes btn-sm dropdown" type="button"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

            <i className="material-icons">
              &#xe5d4;
            </i>

          </button>
          <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <Autorizacao
              perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                  getOperadorRemarcacao(this.props.empresaSelecionada.id)]}>
               {this.exibirImprimirCupomCancelamento()}
            </Autorizacao>
          </div>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = state => (
    {
      empresaSelecionada: state.empresaSelecionada
    });

export default withRouter(connect(mapStateToProps, null)(AcoesRemarcacaoCancelamento))
